import { useQuery } from '@tanstack/react-query';
import client from '../api/client';

export function useExpireAlert(permitdata) {
  const shopId = permitdata?.shop_id;
  const enabled = !!shopId && shopId !== '-';

  const { data } = useQuery({
    queryKey: ['expire-alert-counts', shopId],
    queryFn: async () => {
      const formData = new FormData();
      formData.append('shop_id', shopId);
      formData.append('page', '1');
      formData.append('tab', 'all');
      formData.append('search', '');
      formData.append('seller_only', '1');

      const response = await client.post('/api/product/common/loadconfig', formData, {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'multipart/form-data',
        },
      });
      if (response.data.status !== 'OK') {
        throw new Error(response.data.message || 'loadconfig failed');
      }
      const near = response.data.near_expire_count ?? 0;
      const expired = response.data.tab_counts?.expired ?? 0;
      return { near, expired, hasAlert: near + expired > 0 };
    },
    enabled,
    staleTime: 60_000,
  });

  return {
    nearExpireCount: data?.near ?? 0,
    expiredCount: data?.expired ?? 0,
    hasExpireAlert: data?.hasAlert ?? false,
  };
}
